module.exports = __webpack_public_path__ + "img/video_image.png";